function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #626a84;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Timer",
  transform: "translate(-1549.552 -481.302)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_178",
  "data-name": "Ellipse 178",
  className: "cls-1",
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(1551 484)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_691",
  "data-name": "Path 691",
  className: "cls-1",
  d: "M12,10v3h2",
  transform: "translate(1546 478)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_484",
  "data-name": "Line 484",
  className: "cls-1",
  x1: 2.75,
  y2: 2,
  transform: "translate(1550.25 482)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_485",
  "data-name": "Line 485",
  className: "cls-1",
  x2: 2.75,
  y2: 2,
  transform: "translate(1563 482)"
}));

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.896 17.198",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.a2171218.svg";
export { ForwardRef as ReactComponent };